/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./update-model-button.vue?vue&type=template&id=463d148b&"
import script from "./update-model-button.vue?vue&type=script&lang=ts&"
export * from "./update-model-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports